import { Currency } from '@/core/currency/interfaces';

const BZD: Currency = {
    name: 'Belize Dollar',
    demonym: 'Belize',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '084',
    symbol: 'BZ$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BZD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BZD;
